import { BrowserRouter as Router, Routes, Route, useParams } from "react-router-dom";
  import { useEffect } from "react"
import IndexPage from "./pages/IndexPage";
import SupportPage from "./pages/SupportPage";
import MeetPage from "./pages/MeetPage";

function ExternalRedirect({ url }: { url: string }) {
  useEffect(() => {
    window.location.replace(url);
  }, [url]);

  return null;
}

// New wrapper component for the dream redirect
function DreamRedirect() {
  const { code } = useParams<{ code: string }>();
  if (code && code.length === 8) {
    return <ExternalRedirect url={`https://dreamer.com/join/${code}`} />;
  }
  return <IndexPage expand="dream" />;
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<IndexPage />} />
        <Route path="/about" element={<IndexPage expand="about" />} />
        <Route path="/jobs" element={<IndexPage expand="jobs" />} />
        <Route path="/who" element={<IndexPage expand="who" />} />
        <Route path="/love" element={<IndexPage expand="valentine" />} />
        <Route path="/support" element={<SupportPage />} />
        <Route path="/meet/:person" element={<MeetPage />} />
        <Route path="/dream" element={<IndexPage expand="dream" />} />
        <Route path="/dream/:code" element={<DreamRedirect />} />

        <Route path="/thanks" element={<IndexPage expand="thanks" />} />
        <Route path="/roles/cmt" element={<IndexPage expand="cmt" />} />
        <Route path="/roles/eng" element={<IndexPage expand="eng" />} />
        <Route path="/roles/engm" element={<IndexPage expand="engm" />} />
      </Routes>
    </Router>
  );
}

export default App;
